"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cache = void 0;
const utils_1 = require("../utils");
exports.cache = async function cache(ctx, next) {
    const { request: requestConfig } = ctx;
    // 配置使用缓存
    if (requestConfig.cache) {
        const { cacheKey = utils_1.defaultCacheKey, ttl = 60000, cloneForCache } = requestConfig.cache;
        let _cacheKey = null;
        if (typeof cacheKey === 'string') {
            _cacheKey = cacheKey;
        }
        else if (typeof cacheKey === 'function') {
            _cacheKey = cacheKey(requestConfig);
        }
        if (_cacheKey) {
            const cached = utils_1.REQUEST_CACHE.get(_cacheKey);
            if (cached) {
                const [expired, result] = cached;
                const now = Date.now();
                if (expired > now) {
                    // 缓存未过期, 取出响应返回
                    ctx.response = result;
                    return;
                }
                else {
                    // 缓存过期， 清除缓存
                    utils_1.REQUEST_CACHE.delete(_cacheKey);
                }
            }
            // 未找到缓存或缓存失效
            await next();
            const { response, error } = ctx;
            // 设置缓存
            if (response && !error) {
                const _cloneForCache = cloneForCache || utils_1.defaultCloneResponse;
                const cachedRes = _cloneForCache(Object.assign(Object.assign({}, response), { cacheKey: _cacheKey }));
                const now = Date.now();
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                const expired = ttl ? now + Number(ttl) : Number.MAX_SAFE_INTEGER;
                utils_1.REQUEST_CACHE.set(_cacheKey, [expired, cachedRes]);
            }
            return;
        }
    }
    await next();
};
exports.cache.id = 'cache';
//# sourceMappingURL=cache.js.map